import { BoxLeadFormLayout } from "@modules/boxLead/components/boxLeadForm/boxLeadFormLayout"
import { BoxLeadEntity } from "@modules/boxLead/entities/boxLeadEntity"
import { BoxStaffPermissions } from "@modules/boxStaff/gateway/boxStaffDto"
import { useBoxStaffPermission } from "@modules/boxStaff/hooks/useBoxStaffPermissions"
import { word } from "@modules/core/utils/i18n"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { useConfirmPopup } from "@modules/ui/components/popup/huConfirmPopup"
import { Text } from "@/components/ui/baseUi/text"
import { LoadingSpinner } from "@/modules/ui/components/loading"
import { ErrorBoundary } from "react-error-boundary"
import { ErrorView } from "@/components/ui/layout/error/errorView"
import { Suspense } from "react"

export const useBoxLeadSidebar = () => {
  const { sidebarNavigateTo, hideSidebar } = useSidebar()
  const confirmPopup = useConfirmPopup()
  const canSeeLeads = useBoxStaffPermission(BoxStaffPermissions.SEE_LEADS)

  const bodyClosePopup = (
    <div className="flex flex-col justify-center gap-3">
      <Text fontStyle="TL" className="flex text-textDefault-body">
        {word("boxLead.sidebar.close.title")}
      </Text>
      <Text fontStyle="BM" className="flex text-textDefault-caption">
        {word("boxLead.sidebar.close.message")}
      </Text>
    </div>
  )
  const navigateToBoxLeadForm = (boxLead?: BoxLeadEntity) => {
    // PERMISSIONS - Financial permissions denied
    if (!canSeeLeads) {
      return null
    }

    void sidebarNavigateTo({
      content: (
        <ErrorBoundary fallback={<ErrorView />}>
          <Suspense fallback={<LoadingSpinner />}>
            <BoxLeadFormLayout boxLead={boxLead} />
          </Suspense>
        </ErrorBoundary>
      ),
      replaceAllComponents: true,
      onHide: async () =>
        await new Promise<boolean>((resolve) => {
          confirmPopup.show({
            title: "",
            message: bodyClosePopup,
            accept: () => {
              return Promise.resolve(void resolve(true))
            },
            classNames: {
              dialogContent: "w-105",
            },
            footerProps: {
              cancelText: word("global.cancel"),
              confirmText: word("global.continue"),
            },
          })
        }),
    })
  }

  return {
    hideSidebar,
    navigateToBoxLeadForm,
  }
}
